import UAParser from "ua-parser-js";
import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import { $session } from "dot-framework";

import routerLogin from "@/router/login.js";
import routerTest from "@/router/test.js";
import routerExternal from "@/router/external.js";
import routerApps from "@/router/apps";
import routerEasy from "@/router/easy";
import store from "@/store";
import { whenCompNoReady } from "@/plugin/global";

/**
 * 디바이스 체크
 */
const isDesktopOrUnknownDevice = () => {
    const parser = new UAParser();
    const device = parser.getDevice();
    // Possible 'device.type': console, mobile, tablet, smarttv, wearable, embedded
    return typeof device === "object" && typeof device?.type === "undefined";
};

/**
 * 라우트 정의
 */
const routes = [
    {
        name: "appCheckBroker",
        path: "/appCheckBroker",
        meta: {
            layout: "BlankLayout",
            title: "Dot Apps",
            auth: false,
        },
        component: () => import("@/view/AppCheckBroker.vue"),
    },
    ...routerApps,
    ...routerEasy,
    ...routerLogin,
    ...routerTest,
    ...routerExternal,
];

/**
 * 인증 없이 접근 가능한 라우트 이름
 */
const whiteList = [
    "appCheckBroker",
    "login",
    "login-callback",
    "support",
    "dotEasyHome",
];

/**
 * Router 생성
 */
const router = createRouter({
    history:
        process.env.VUE_APP_IS_ELECTRON === "true"
            ? createWebHashHistory()
            : createWebHistory(),
    routes,
});

/**
 * 전역 라우터 가드
 */
router.beforeEach(async (to, from, next) => {
    /* --------------------------------------------------
     * 디바이스 체크
     * -------------------------------------------------- */
    if (
        !isDesktopOrUnknownDevice() &&
        to.name !== "appCheckBroker" &&
        from.name !== "appCheckBroker"
    ) {
        return next({ name: "appCheckBroker" });
    }
    const isNotNeedsAuth = to.matched.some(
        record => record.meta?.auth === false
    );

    /* --------------------------------------------------
     * 인증이 필요 없는 페이지
     * -------------------------------------------------- */
    if (whiteList.includes(to.name)) {
        return next();
    }

    /*
     * 업체번호가 있어야 API 경로를 만들 수 있다. 화면이 먼저 뜨면 업체번호 자리가 빈
     * 경로로 요청이 나가 412 를 받고, 그 실패가 토큰 만료로 오인돼 갱신·재시도까지
     * 번진다. 로그인이 필요한 화면은 여기서 한 번 기다려 준다.
     * (조회가 실패하거나 늦으면 whenCompNoReady 쪽에서 알아서 풀어 준다)
     */
    await whenCompNoReady();

    if (store.getters["auth/isAuthenticated"] === null) {
        const ok = await $session.ensureLoggedIn();
        store.commit("auth/setAuthenticated", ok);
    }

    if (isNotNeedsAuth) {
        return next();
    }

    if (!store.getters["auth/isAuthenticated"]) {
        return next({
            name: "login",
            query: { redirect: to.fullPath },
        });
    }

    return next();
});

router.afterEach((to) => {
    const path = to.path.split("/").filter(Boolean).join(", ");
    document.title =
        to.meta.title === undefined
            ? `Dot Apps : ${path}`
            : to.meta.title;
});

export { router };